// @core/api/endpoints/localization/get_translation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TranslationResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Get translation
 * Retrieves a specific translation by ID.
 */
export async function GetTranslation(
  translation_id: string,
  options?: RequestOptions
): Promise<TranslationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/localization/translations/:translation_id`;
  requestPath = requestPath.replace(':translation_id', encodeURIComponent(translation_id));
  const requestOptions = options;
  return client.get<TranslationResponse>(requestPath, { ...requestOptions });
}
